"use client";

import _defineProperty from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
var __jsx = React.createElement;
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React, { useEffect, useState } from 'react';
const StoryblokLogo = _ref => {
  let {
    height,
    className,
    srcGetter,
    cacheKey,
    alt,
    style
  } = _ref;
  const {
    0: logoSrc,
    1: setLogoSrc
  } = useState('');
  useEffect(() => {
    getAndSetLogoSrc();
  }, []);
  const getAndSetLogoSrc = async () => {
    const cachedEntotyLogoSrc = sessionStorage.getItem(cacheKey || '');
    if (cachedEntotyLogoSrc) {
      setLogoSrc(cachedEntotyLogoSrc);
    } else {
      const logoSrc = await srcGetter();
      setLogoSrc(logoSrc);
      sessionStorage.setItem(cacheKey || '', logoSrc);
    }
  };
  return logoSrc !== '' ? __jsx("img", {
    className: className,
    src: logoSrc,
    style: _objectSpread({
      height: height,
      objectFit: 'contain'
    }, style),
    alt: alt
  }) : null;
};
export default StoryblokLogo;